module.exports = __webpack_public_path__ + "static/media/colonrectalcancer.bf444e4c.svg";